/**
 * The person's screen theme, live: the header's ThemeButton, the avatar menu's
 * ThemeChoice and Settings → Preferences all read it, and each re-renders when
 * any of them calls setTheme() (themebtn, 3 Nov 2026).
 */
import { useSyncExternalStore } from 'react';
import { getStoredTheme, isDarkNow, THEME_EVENT, type ThemePref } from '../utils/theme';

function subscribe(onChange: () => void): () => void {
    window.addEventListener(THEME_EVENT, onChange);
    // 'system' follows the OS; initTheme re-applies it, this re-reads it.
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    mq.addEventListener('change', onChange);
    return () => {
        window.removeEventListener(THEME_EVENT, onChange);
        mq.removeEventListener('change', onChange);
    };
}

/** The stored choice: 'light' | 'dark' | 'system'. */
export function useThemePref(): ThemePref {
    return useSyncExternalStore(subscribe, getStoredTheme, () => 'system');
}

/** Whether the screen is dark now, whatever the choice resolved to. */
export function useDarkNow(): boolean {
    return useSyncExternalStore(subscribe, isDarkNow, () => false);
}
